import React from 'react';
import failedStateMessages from '../../messages';
import { messages } from '../../experience-application/messages';
import { getBooleanFF } from '@atlaskit/platform-feature-flags';
export const getErrorMessage = content => {
  switch (content) {
    case 'INPUT_EXCEEDS_TOKEN_LIMIT':
      return failedStateMessages.tokenLimitExceeded;
    case 'INPUT_TOO_SHORT_TO_SUMMARIZE':
      return failedStateMessages.inputTooShortError;
    case 'INPUT_TOO_SHORT_TO_PROCESS':
      return failedStateMessages.inputTooShortError;
    case 'RATE_LIMIT':
      return failedStateMessages.rateLimitEnforced;
    case 'OPENAI_RATE_LIMIT_USER_ABUSE':
      return failedStateMessages.rateLimitEnforced;
    case 'NO_AGENT':
      return failedStateMessages.internalServerError;
    case 'FEATURE_DISABLED_ON_SITE':
      return failedStateMessages.internalServerError;
    case 'FEATURE_DISABLED':
      return failedStateMessages.internalServerError;
    case 'INTERNAL_SERVER_ERROR':
      return failedStateMessages.internalServerError;
    case 'PLUGIN_ERRORED':
      return failedStateMessages.internalServerError;
    case 'HIPAA_CONTENT_DETECTED':
      return failedStateMessages.hipaaContentError;
    case 'EXCEEDING_CONTEXT_LENGTH_ERROR':
      return failedStateMessages.tokenLimitExceeded;
    default:
      return failedStateMessages.apiError;
  }
};
export const getAupViolationMessage = formatMessage => {
  return formatMessage(messages.aupViolationMessage, {
    auplink: chunks => /*#__PURE__*/React.createElement("a", {
      href: "https://www.atlassian.com/legal/acceptable-use-policy",
      target: "_blank"
    }, chunks)
  });
};
export const getInternalServerErrorMessage = formatMessage => {
  return formatMessage(failedStateMessages.internalServerError, {
    link: chunks => /*#__PURE__*/React.createElement("a", {
      href: "https://status.atlassian.com/",
      target: "_blank"
    }, chunks)
  });
};
export const getRateLimitErrorMessage = formatMessage => {
  return formatMessage(failedStateMessages.rateLimitEnforced, {
    link: chunks => /*#__PURE__*/React.createElement("a", {
      href: "https://support.atlassian.com/organization-administration/docs/excessive-use-in-atlassian-intelligence/",
      target: "_blank"
    }, chunks)
  });
};
export const getRegenerateToolbarItem = (intl, api, extensionKey, messages) => {
  return {
    key: 'regenerate-button',
    label: intl.formatMessage(messages.regenerateButtonLabel),
    display: 'icon-and-label',
    tooltip: intl.formatMessage(messages.regenerateButtonTooltip),
    icon: () => import('@atlaskit/icon/glyph/retry').then(mod => mod.default),
    action: async adf => {
      var _adf$attrs;
      if (!((_adf$attrs = adf.attrs) !== null && _adf$attrs !== void 0 && _adf$attrs.localId) || !api || !api.aiExperience) {
        return;
      }
      api.aiExperience.actions.regenerateExtension(adf.attrs.localId, extensionKey);
    },
    disabled: !api || !api.aiExperience
  };
};
export const isAIPanelsEnabled = () => {
  let aiPanelsEnabled = false;
  if (getBooleanFF('platform.editor.ai.enable-ai-summary-blocks_r040m')) {
    aiPanelsEnabled = true;
  }
  if (getBooleanFF('platform.editor.ai.enable-ai-action-items-block_vctyf')) {
    aiPanelsEnabled = true;
  }
  return aiPanelsEnabled;
};
export const getFeedbackToolbarItem = (intl, api, messages) => {
  return {
    key: 'feedback-button',
    label: intl.formatMessage(messages.feedbackButtonLabelTooltip),
    display: 'icon',
    tooltip: intl.formatMessage(messages.feedbackButtonLabelTooltip),
    icon: () => import('@atlaskit/icon/glyph/editor/feedback').then(mod => mod.default),
    action: async adf => {
      var _adf$attrs2, _adf$attrs3, _adf$attrs4, _adf$attrs4$parameter, _api$analytics, _api$analytics$action;
      if (!((_adf$attrs2 = adf.attrs) !== null && _adf$attrs2 !== void 0 && _adf$attrs2.localId) || !api || !api.aiExperience) {
        return;
      }
      api.aiExperience.actions.triggerAIPanelFeedbackCollector(adf === null || adf === void 0 ? void 0 : (_adf$attrs3 = adf.attrs) === null || _adf$attrs3 === void 0 ? void 0 : _adf$attrs3.extensionKey, adf === null || adf === void 0 ? void 0 : (_adf$attrs4 = adf.attrs) === null || _adf$attrs4 === void 0 ? void 0 : (_adf$attrs4$parameter = _adf$attrs4.parameters) === null || _adf$attrs4$parameter === void 0 ? void 0 : _adf$attrs4$parameter.content, intl.locale, api === null || api === void 0 ? void 0 : (_api$analytics = api.analytics) === null || _api$analytics === void 0 ? void 0 : (_api$analytics$action = _api$analytics.actions) === null || _api$analytics$action === void 0 ? void 0 : _api$analytics$action.fireAnalyticsEvent);
    },
    disabled: !api || !api.aiExperience
  };
};